Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHANNEL = exports.CHANNEL = '__direction__';

var DIRECTIONS = exports.DIRECTIONS = {
  LTR: 'ltr',
  RTL: 'rtl'
};


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-with-direction/dist/constants.js
// module id = 4320
// module chunks = 168707334958949